//  taken from https://github.com/facebook/react/blob/b87aabdfe1b7461e7331abb3601d9e6bb27544bc/packages/react-dom/src/shared/CSSProperty.js
var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  columns: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridArea: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,
  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};
export var setStylesAndCreateResetter = function setStylesAndCreateResetter(node, styles) {
  var orgStyles = {};
  Object.entries(styles).forEach(function (_ref) {
    var prop = _ref[0],
        val = _ref[1];
    orgStyles[prop] = node.style[prop];
    node.style[prop] = typeof val === "number" && !isUnitlessNumber[prop] ? val + "px" : val;
  });
  return function () {
    Object.entries(orgStyles).forEach(function (_ref2) {
      var prop = _ref2[0],
          val = _ref2[1];
      node.style[prop] = val;
    });
  };
};